module.exports = __webpack_public_path__ + "static/media/A7407885.c3dc839e.jpg";